import { createRoutine } from 'redux-saga-routines';
import { CLOSE_POP_UP, OPEN_POP_UP } from './types';

export const openPopup = createRoutine(OPEN_POP_UP);
export const closePopup = createRoutine(CLOSE_POP_UP);
